import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
// import { WidgetsData } from "../../common/data/dashboard";

//import countup
import CountUp from 'react-countup';

//import Charts
import ReactApexChart from 'react-apexcharts';

const Widgets = ({ options, items }: any) => {
  return (
    <React.Fragment>
      {(items || []).map((item: any, key: number) => (
        <Col xl={3} md={6} key={key}>
          <Card className="card-h-100">
            <CardBody>
              <Row className="align-items-center">
                <span className="text-muted mb-3 lh-1 d-block text-truncate">
                  {
                    <p style={{ color: `${options['ColorTitle']}` }}>
                      {item['title']}
                    </p>
                  }
                </span>
                <Row className="align-items-center">
                  <Col xs={12}>
                    <h4 className="mb-3">
                      {item['isDoller'] === true ? '$' : ''}
                      <span className="counter-value">
                        <CountUp
                          start={0}
                          end={item['price']}
                          duration={3}
                          separator="."
                          decimals={0}
                          decimal=","
                        />
                        {item['postFix']}
                      </span>
                    </h4>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col xs={12} className="align-items-center">
                    <ReactApexChart
                      options={options}
                      series={[{ data: [...item['series']] }]}
                      type="line"
                      className="apex-charts"
                      dir="ltr"
                      height={'140px'}
                    />
                  </Col>
                </Row>
              </Row>
            </CardBody>
          </Card>
        </Col>
      ))}
    </React.Fragment>
  );
};

export default Widgets;
